import logo from '@/images/did_logo_dark.svg';
import styled from '@emotion/styled';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    margin-block: 24px;
    gap: 9px;
    align-items: center;
    bottom: 0;

    &:hover {
        cursor: pointer;
    }
`;

const Text = styled.span`
    color: ${({ theme }) => theme.colors.black[800]};
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

const Logo = styled.img`
    width: 24px;
    height: 20px;
`;

const promoUrl = 'https://www.d-id.com/?from=campaigns_video_page';

export const Footer = () => {
    return (
        <Container
            onClick={() => {
                window.open(promoUrl, '_blank');
            }}>
            <Text>Powered by</Text>
            <Logo src={logo} />
        </Container>
    );
};
